import { render, staticRenderFns } from "./submenu.vue?vue&type=template&id=cbaa8a08&"
import script from "./submenu.vue?vue&type=script&lang=js&"
export * from "./submenu.vue?vue&type=script&lang=js&"
import style0 from "./submenu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports